import MasterDataStore from '@component_path/lib/masterDataStore';

window.addEventListener('load', () => MasterDataStore.setAllMasterData());